import React from 'react'
import { Home, Welcome, AllRegistration, 
  AllApplications, AllDocumentVerify,AllPaymentList,
  AllNotifications,AllAuditList, AllQAA,AllApproval,
  RegistrationForm, SignIn, DisplayRecord, MyPayments, MySchedules, Dashboard, AllFinance, ShowApplicantDetails, MyAudits, AdminUserRegistration, AllUsers, Reports, ClientAuditFeedback, ManualPaymentClearance, CertificateManagement, 
  SuspendCertificate, UpliftCertificateSuspension, UgPassValidate, IdleTimeout, AssignedUsers, GTBankPaymentForm, GeneratedPRNs, AllAuditReports, MyLicenses, AllSignedCertificates, ApprovedList } from './_screens'

function App() {
  const [ link, setLink ] = React.useState( null )

  const handleIdle = () => {
    localStorage.clear();
    // Perform any other actions you need when the application is idle.
    return window.location.reload()
  };
  
  <IdleTimeout timeout={300000} onIdle={handleIdle} />

  if( localStorage.getItem( "link" ) === "change_password" ) {
    return <SignIn changePassword={true} />
  }

  if( localStorage.getItem( "link" ) === "welcome" ) {
    return  <Welcome />
  } 

  if( localStorage.getItem( "link" ) === "it_registration" ) {
    return <AllRegistration />
  }

  if( localStorage.getItem( "link" ) === "it_application" ) {
    return <AllApplications />
  }

  if( localStorage.getItem( "link" ) === "it_assurance" ) {
    return <AllQAA />
  }

  if( localStorage.getItem( "link" ) === "it_approval" ) {
    return <AllApproval />
  }

  if( localStorage.getItem( "link" ) === "notifications" ) {
    return <AllNotifications />
  }

  if( localStorage.getItem( "link" ) === "it_document" ) {
    return <AllDocumentVerify />
  }

  if( localStorage.getItem( "link" ) === "audit" ) {
    return <AllAuditList />
  }

  if( localStorage.getItem( "link" ) === "it_payment" ) {
    return <AllPaymentList />
  }

  if( localStorage.getItem( "link" ) === "payments" ) {
    return <MyPayments />
  }
  if( localStorage.getItem( "link" ) === "schedules" ) {
    return <MySchedules />
  }

  if( localStorage.getItem( "link" ) === "register" ) {
    return <RegistrationForm />
  }

  if( localStorage.getItem( "link" ) === "sign_in" ) {
    return <SignIn />
  }

  if( localStorage.getItem( "link" ) === "display" ) {
    return <DisplayRecord />
  }

  if( localStorage.getItem( "link" ) === "home" ) {
    return <Home />
  }

  if( localStorage.getItem( "link" ) === "dashboard" ) {
    return <Dashboard />
  }

  if( localStorage.getItem( "link" ) === "finance" ){
    return <AllFinance />
  }

  if( localStorage.getItem( "link" ) === "non_ura_payments" ){
    return <AllFinance />
  } 

  if( localStorage.getItem( "link" ) === "generated_prns" ){
    return <GeneratedPRNs />
  } 

  if( localStorage.getItem( "link" ) === "action_manual_payment" ){
    return <ManualPaymentClearance />
  }

  if( localStorage.getItem( "link" ) === "application_details" ){
    return <ShowApplicantDetails />
  }

  if( localStorage.getItem( "link" ) === "new_admin_user" ){
    return <AdminUserRegistration />
  }

  if( localStorage.getItem( "link" ) === "all_users" ){
    return <AllUsers />
  }

  if( localStorage.getItem( "link" ) === "all_applicants" ){
    return <AllUsers />
  }

  if( localStorage.getItem( "link" ) === "audits" ){
    return <MyAudits />
  }

  if( localStorage.getItem( "link" ) === "licenses" ){
    return <MyLicenses />
  }

  if( localStorage.getItem( "link" ) === "client_audit_feedback" ){
    return <ClientAuditFeedback />
  }

  if( localStorage.getItem( "link" ) === "assigned_users_to_applications"){
    return <AssignedUsers />
  }

  if( localStorage.getItem( "link" ) === "assigned_users_details"){
    return <AssignedUsers />
  }

  if( localStorage.getItem( "link" ) === "user_registrations_report"){
    return <Reports />
  }

  if( localStorage.getItem( "link" ) === "isic_codes_report"){
    return <Reports />
  }

  if( localStorage.getItem( "link" ) === "per_district_apps_report"){
    return <Reports />
  }

  if( localStorage.getItem( "link" ) === "renewal_applications_report"){
    return <Reports />
  }

  if( localStorage.getItem( "link" ) === "per_gender_apps_report"){
    return <Reports />
  }

  if( localStorage.getItem( "link" ) === "certification_levels_report"){
    return <Reports />
  }

  if( localStorage.getItem( "link" ) === "renewals_vs_new_applications"){
    return <Reports />
  }

  if( localStorage.getItem( "link" ) === "approved_by_manager_report"){
    return <Reports />
  }

  if( localStorage.getItem( "link" ) === "issued_certificates"){
    return <CertificateManagement />
  }

  if( localStorage.getItem( "link" ) === "certificate_progress"){
    return <CertificateManagement />
  }

  if( localStorage.getItem( "link" ) === "suspend_certificates"){
    return <CertificateManagement />
  }

  if( localStorage.getItem( "link" ) === "suspend_certificate"){
    return <SuspendCertificate />
  }

  if( localStorage.getItem( "link" ) === "uplift_suspensions"){
    return <CertificateManagement />
  }

  if( localStorage.getItem( "link" ) === "uplift_suspension"){
    return <UpliftCertificateSuspension />
  }

  if( localStorage.getItem( "link" ) === "gt_bank_payment"){
    return <GTBankPaymentForm />
  }

  if( localStorage.getItem( "link" ) === "all_audit_reports"){
    return <AllAuditReports />
  }

  if( localStorage.getItem( "link" ) === "all_signed_certificates"){
    return <AllSignedCertificates />
  }

  if( localStorage.getItem( "link" ) === "paid_but_not_signed"){
    return <AllSignedCertificates />
  }

  if( localStorage.getItem( "link" ) === "about_to_expire"){
    return <AllSignedCertificates />
  }

  if( localStorage.getItem( "link" ) === "timelines_report"){
    return <Reports />
  }

  if( localStorage.getItem( "link" ) === "approved_list"){
    return <ApprovedList />
  }

  if( localStorage.getItem( "link" ) === "pending_list"){
    return <ApprovedList />
  }

  if( localStorage.getItem( "link" ) === "ugpass_validate"){
    return <UgPassValidate />
  }

  if( localStorage.getItem( "link" ) === "add_client_document"){
    return <MyAudits />
  }

  return (
    <>
      <Home />
    </>
  //  <div className="h-screen w-screen overflow-hidden flex flex-col items-center justify-center">
  //     <div onClick={ async() => {
  //       await localStorage.setItem( "link", "welcome" )
  //       window.location.reload()
  //     } } className="cursor-pointer text-xs text-green-700">
  //       {`Site under maintenance`}
  //     </div>
  //     <div onClick={ async() => {
  //       await localStorage.setItem( "link", "register" )
  //       window.location.reload()
  //     } } className="m-2 cursor-pointer text-xs text-green-700">
  //       {`Register`}
  //     </div>
  //     <div onClick={ async() => {
  //       await localStorage.setItem( "link", "sign_in" )
  //       window.location.reload()
  //     } } className="m-2 cursor-pointer text-xs text-green-700">
  //       {`Login`}
  //     </div>
  //  </div>
  );
} 
export default App;
